/** Shared prop/types for the `<ImageGallery>` family. */
import type { QueryKey } from '@tanstack/react-query';

import type { GalleryImage, ImageGalleryApi } from '@/api/media';

export type { GalleryImage, ImageGalleryApi, GalleryPatch } from '@/api/media';

export interface ImageGalleryProps {
  /** Parent-scoped api (from `makeGalleryApi(kind, parentId)`). */
  api: ImageGalleryApi;
  /** React-query cache key the component owns; every mutation invalidates it. */
  queryKey: QueryKey;
  /** When false the gallery is a read-only viewer (grid + lightbox, no controls). */
  canManage: boolean;
  /** Itinerary galleries expose the per-image `show_in_group` switch. */
  showInGroup?: boolean;
}

/** An image whose backend `download_status` marks it as still fetching a source URL. */
export const DOWNLOAD_IN_PROGRESS = [2, 3] as const;

export function isDownloading(img: GalleryImage): boolean {
  return (DOWNLOAD_IN_PROGRESS as readonly number[]).includes(img.download_status);
}
